// Rewarded / interstitial ad adapter.
//
// Ads are presented by <AdHost/> as polished house ".io game" creatives so the
// slots always show a real-looking, working ad everywhere (preview + live).
// If REACT_APP_AD_PUBLISHER_ID (+ REACT_APP_AD_INTERSTITIAL_SLOT) are set on the
// live domain, a real AdSense interstitial unit is loaded/shown as well.
// Rewards themselves are always validated server-side.
const PUBLISHER_ID = process.env.REACT_APP_AD_PUBLISHER_ID || null;
const INTERSTITIAL_SLOT = process.env.REACT_APP_AD_INTERSTITIAL_SLOT || null;

let scriptLoaded = false;
function loadNetwork() {
  if (scriptLoaded || !PUBLISHER_ID || typeof document === "undefined") return;
  scriptLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.crossOrigin = "anonymous";
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${PUBLISHER_ID}`;
  document.head.appendChild(s);
}

let presenter = null; // set by <AdHost/> once mounted

export const AdManager = {
  publisherId: PUBLISHER_ID,
  interstitialSlot: INTERSTITIAL_SLOT,
  get networkActive() { return !!PUBLISHER_ID; },
  init() { loadNetwork(); },

  // Renders/refreshes a pending <ins class="adsbygoogle"> unit. Safe no-op in
  // preview (no publisher id) and guarded so a missing script never throws.
  pushAd() {
    if (!PUBLISHER_ID) return;
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) { console.warn("ad push failed", e); }
  },

  // <AdHost/> registers itself here so any call site can present an ad overlay.
  _setPresenter(fn) { presenter = fn; },

  // Rewarded ad — resolves once the viewer has watched (or engaged with) the ad.
  playRewarded({ seconds = 5 } = {}) {
    this.init();
    return this._present({ kind: "rewarded", seconds });
  },

  // Interstitial shown between matches for players who haven't removed ads.
  playInterstitial({ seconds = 5 } = {}) {
    this.init();
    return this._present({ kind: "interstitial", seconds });
  },

  _present(opts) {
    if (!presenter) return this._timed(opts.seconds); // fallback if host not mounted yet
    return new Promise((resolve) => presenter({ ...opts, resolve }));
  },

  // Fallback timer (used only if the overlay host isn't mounted).
  _timed(seconds) {
    return new Promise((resolve) => {
      let s = seconds;
      const it = setInterval(() => { s -= 1; if (s <= 0) { clearInterval(it); resolve({ completed: true }); } }, 1000);
    });
  },
};
